import React from 'react'
import styled from 'styled-components'

import H1 from './Typography/H1'
import Intro from './Typography/Intro'
import ReturnToHomepage from './ReturnToHomepage'

import useTranslate from '../hooks/useTranslate'

const ButtonWrap = styled.div`
  margin-bottom: 20px;
`

const NoFormSessionError = () => {
  const translate = useTranslate()
  return (
    <React.Fragment>
      <H1>{translate('NO_FORM_SESSION_ERROR_HEADING')}</H1>
      <Intro isSummary>{translate('NO_FORM_SESSION_ERROR_DESCRIPTION')}</Intro>
      <ButtonWrap>
        <ReturnToHomepage />
      </ButtonWrap>
    </React.Fragment>
  )
}

export default NoFormSessionError
